export default {
  'Diego Lopes': {
    displayName: 'Diego Lopes',
    logoUrl: 'flags/brazil.webp',
  },
  'Jean Silva': {
    displayName: 'Jean Silva',
    logoUrl: 'flags/brazil.webp',
  },
  'Rob Font': {
    displayName: 'Rob Font',
    logoUrl: 'flags/united_states.webp',
  },
  'David Martinez': {
    displayName: 'David Martinez',
    logoUrl: 'flags/mexico.webp',
  },
  'Rafa Garcia': {
    displayName: 'Rafa Garcia',
    logoUrl: 'flags/united_states.webp',
  },
  'Jared Gordon': {
    displayName: 'Jared Gordon',
    logoUrl: 'flags/united_states.webp',
  },
  'Kelvin Gastelum': {
    displayName: 'Kelvin Gastelum',
    logoUrl: 'flags/united_states.webp',
  },
  'Dustin Stoltzfus': {
    displayName: 'Dustin Stoltzfus',
    logoUrl: 'flags/united_states.webp',
  },
  'Santiago Luna': {
    displayName: 'Santiago Luna',
    logoUrl: 'flags/venezuela.webp',
  },
  'Quang Le': {
    displayName: 'Quang Le',
    logoUrl: 'flags/vietnam.webp',
  },
  'Alexander Hernandez': {
    displayName: 'Alexander Hernandez',
    logoUrl: 'flags/united_states.webp',
  },
  'Caio Borralho': {
    displayName: 'Caio Borralho',
    logoUrl: 'flags/brazil.webp',
  },
  'Mauricio Ruffy': {
    displayName: 'Mauricio Ruffy',
    logoUrl: 'flags/brazil.webp',
  },
  'Benoit Saint-Denis': {
    displayName: 'Benoit Saint-Denis',
    logoUrl: 'flags/france.webp',
  },
  'Paul Craig': {
    displayName: 'Paul Craig',
    logoUrl: 'flags/scotland.webp',
  },
  'Modestas Bukauskas': {
    displayName: 'Modestas Bukauskas',
    logoUrl: 'flags/lithuania.webp',
  },
  'Bolaji Oki': {
    displayName: 'Bolaji Oki',
    logoUrl: 'flags/belgium.webp',
  },
  'Mason Jones': {
    displayName: 'Mason Jones',
    logoUrl: 'flags/wales.webp',
  },
  'Rhys McKee': {
    displayName: 'Rhys McKee',
    logoUrl: 'flags/ireland.webp',
  },
  'Axel Sola': {
    displayName: 'Axel Sola',
    logoUrl: 'flags/france.webp',
  },
  'Robert Ruchala': {
    displayName: 'Robert Ruchala',
    logoUrl: 'flags/poland.webp',
  },
  'William Gomis': {
    displayName: 'William Gomis',
    logoUrl: 'flags/france.webp',
  },
  'Brendson Ribeiro': {
    displayName: 'Brendson Ribeiro',
    logoUrl: 'flags/brazil.webp',
  },
  'Oumar Sy': {
    displayName: 'Oumar Sy',
    logoUrl: 'flags/france.webp',
  },
  'Ante Delija': {
    displayName: 'Ante Delija',
    logoUrl: 'flags/croatia.webp',
  },
  'Marcin Tybura': {
    displayName: 'Marcin Tybura',
    logoUrl: 'flags/poland.webp',
  },
  'Harry Hardwick': {
    displayName: 'Harry Hardwick',
    logoUrl: 'flags/england.webp',
  },
  'Kaue Fernandes': {
    displayName: 'Kaue Fernandes',
    logoUrl: 'flags/brazil.webp',
  },
  'Trey Waters': {
    displayName: 'Trey Waters',
    logoUrl: 'flags/united_states.webp',
  },
  'Sam Patterson': {
    displayName: 'Sam Patterson',
    logoUrl: 'flags/england.webp',
  },
  'Andreas Gustafsson': {
    displayName: 'Andreas Gustafsson',
    logoUrl: 'flags/sweden.webp',
  },
  'Rinat Fakhretdinov': {
    displayName: 'Rinat Fakhretdinov',
    logoUrl: 'flags/russia.webp',
  },
  'Sam Hughes': {
    displayName: 'Sam Hughes',
    logoUrl: 'flags/united_states.webp',
  },
  'Shauna Bannon': {
    displayName: 'Shauna Bannon',
    logoUrl: 'flags/ireland.webp',
  },
  'Donte Johnson': {
    displayName: 'Donte Johnson',
    logoUrl: 'flags/united_states.webp',
  },
  'Sedriques Dumas': {
    displayName: 'Sedriques Dumas',
    logoUrl: 'flags/united_states.webp',
  },
  'Seokhyeon Ko': {
    displayName: 'Seokhyeon Ko',
    logoUrl: 'flags/south_korea.webp',
  },
  'Phil Rowe': {
    displayName: 'Phil Rowe',
    logoUrl: 'flags/united_states.webp',
  },
  'Kevin Christian': {
    displayName: 'Kevin Christian',
    logoUrl: 'flags/brazil.webp',
  },
  'Billy Elekana': {
    displayName: 'Billy Elekana',
    logoUrl: 'flags/united_states.webp',
  },
  'Daniel Frunza': {
    displayName: 'Daniel Frunza',
    logoUrl: 'flags/romania.webp',
  },
  'Charles Radtke': {
    displayName: 'Charles Radtke',
    logoUrl: 'flags/united_states.webp',
  },
  'Montserrat Rendon': {
    displayName: 'Montserrat Rendon',
    logoUrl: 'flags/mexico.webp',
  },
  'Alice Ardelean': {
    displayName: 'Alice Ardelean',
    logoUrl: 'flags/romania.webp',
  },
  'Chang Ho Lee': {
    displayName: 'Chang Ho Lee',
    logoUrl: 'flags/south_korea.webp',
  },
  'Timmy Cuamba': {
    displayName: 'Timmy Cuamba',
    logoUrl: 'flags/united_states.webp',
  },
  'Norma Dumont': {
    displayName: 'Norma Dumont',
    logoUrl: 'flags/brazil.webp',
  },
  'Ketlen Vieira': {
    displayName: 'Ketlen Vieira',
    logoUrl: 'flags/brazil.webp',
  },
  'Ariane Carnelossi': {
    displayName: 'Ariane Carnelossi',
    logoUrl: 'flags/brazil.webp',
  },
  'Talita Alencar': {
    displayName: 'Talita Alencar',
    logoUrl: 'flags/brazil.webp',
  },
  'Yadier Del Valle': {
    displayName: 'Yadier Del Valle',
    logoUrl: 'flags/cuba.webp',
  },
  'Isaac Dulgarian': {
    displayName: 'Isaac Dulgarian',
    logoUrl: 'flags/united_states.webp',
  },
  'Cody Durden': {
    displayName: 'Cody Durden',
    logoUrl: 'flags/united_states.webp',
  },
  'Allan Nascimento': {
    displayName: 'Allan Nascimento',
    logoUrl: 'flags/brazil.webp',
  },
  'Montserrat Ruiz': {
    displayName: 'Montserrat Ruiz',
    logoUrl: 'flags/mexico.webp',
  },
  'David Onama': {
    displayName: 'David Onama',
    logoUrl: 'flags/uganda.webp',
  },
  'Steve Garcia': {
    displayName: 'Steve Garcia',
    logoUrl: 'flags/united_states.webp',
  },
  'Waldo Cortes-Acosta': {
    displayName: 'Waldo Cortes-Acosta',
    logoUrl: 'flags/dominican_republic.webp',
  },
  'Themba Gorimbo': {
    displayName: 'Themba Gorimbo',
    logoUrl: 'flags/zimbabwe.webp',
  },
  'Lorenzo Musetti': {
    displayName: 'Lorenzo Musetti',
    logoUrl: 'flags/italy.webp',
  },
  'Jeremiah Wells': {
    displayName: 'Jeremiah Wells',
    logoUrl: 'flags/united_states.webp',
  },
  'Hyder Amil': {
    displayName: 'Hyder Amil',
    logoUrl: 'flags/united_states.webp',
  },
  'Jamall Emmers': {
    displayName: 'Jamall Emmers',
    logoUrl: 'flags/united_states.webp',
  },
  'Max Gimenis': {
    displayName: 'Max Gimenis',
    logoUrl: 'flags/brazil.webp',
  },
  'Josh Hokit': {
    displayName: 'Josh Hokit',
    logoUrl: 'flags/united_states.webp',
  },
  'Tecia Pennington': {
    displayName: 'Tecia Pennington',
    logoUrl: 'flags/united_states.webp',
  },
  'Denise Gomes': {
    displayName: 'Denise Gomes',
    logoUrl: 'flags/brazil.webp',
  },
  'Jackson McVey': {
    displayName: 'Jackson McVey',
    logoUrl: 'flags/united_states.webp',
  },
  'Robert Valentin': {
    displayName: 'Robert Valentin',
    logoUrl: 'flags/switzerland.webp',
  },
  'Mayra Bueno Silva': {
    displayName: 'Mayra Bueno Silva',
    logoUrl: 'flags/brazil.webp',
  },
  'Jacqueline Cavalcanti': {
    displayName: 'Jacqueline Cavalcanti',
    logoUrl: 'flags/portugal.webp',
  },
  'Melissa Croden': {
    displayName: 'Melissa Croden',
    logoUrl: 'flags/canada.webp',
  },
  'Luana Santos': {
    displayName: 'Luana Santos',
    logoUrl: 'flags/brazil.webp',
  },
  'Cristian Quinonez': {
    displayName: 'Cristian Quinonez',
    logoUrl: 'flags/mexico.webp',
  },
  'Adrian Yanez': {
    displayName: 'Adrian Yanez',
    logoUrl: 'flags/united_states.webp',
  },
  'Randy Brown': {
    displayName: 'Randy Brown',
    logoUrl: 'flags/jamaica.webp',
  },
  'Gabriel Bonfim': {
    displayName: 'Gabriel Bonfim',
    logoUrl: 'flags/brazil.webp',
  },
  'Ricky Simon': {
    displayName: 'Ricky Simon',
    logoUrl: 'flags/united_states.webp',
  },
  'Raoni Barcelos': {
    displayName: 'Raoni Barcelos',
    logoUrl: 'flags/brazil.webp',
  },
  'Matt Schnell': {
    displayName: 'Matt Schnell',
    logoUrl: 'flags/united_states.webp',
  },
  'Joseph Morales': {
    displayName: 'Joseph Morales',
    logoUrl: 'flags/united_states.webp',
  },
  'Chris Padilla': {
    displayName: 'Chris Padilla',
    logoUrl: 'flags/united_states.webp',
  },
  'Ismael Bonfim': {
    displayName: 'Ismael Bonfim',
    logoUrl: 'flags/brazil.webp',
  },
  'Uros Medic': {
    displayName: 'Uros Medic',
    logoUrl: 'flags/serbia.webp',
  },
  'Muslim Salikhov': {
    displayName: 'Muslim Salikhov',
    logoUrl: 'flags/russia.webp',
  },
  'Marco Tulio': {
    displayName: 'Marco Tulio',
    logoUrl: 'flags/brazil.webp',
  },
  'Christian Leroy Duncan': {
    displayName: 'Christian Leroy Duncan',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Cody Haddon': {
    displayName: 'Cody Haddon',
    logoUrl: 'flags/australia.webp',
  },
  'Malcolm Wellmaker': {
    displayName: 'Malcolm Wellmaker',
    logoUrl: 'flags/united_states.webp',
  },
  'Pat Sabatini': {
    displayName: 'Pat Sabatini',
    logoUrl: 'flags/united_states.webp',
  },
  'Chepe Mariscal': {
    displayName: 'Chepe Mariscal',
    logoUrl: 'flags/united_states.webp',
  },
  'Angela Hill': {
    displayName: 'Angela Hill',
    logoUrl: 'flags/united_states.webp',
  },
  'Fatima Kline': {
    displayName: 'Fatima Kline',
    logoUrl: 'flags/united_states.webp',
  },
  'Gerald Meerschaert': {
    displayName: 'Gerald Meerschaert',
    logoUrl: 'flags/united_states.webp',
  },
  'Kyle Daukaus': {
    displayName: 'Kyle Daukaus',
    logoUrl: 'flags/united_states.webp',
  },
  'Beneil Dariush': {
    displayName: 'Beneil Dariush',
    logoUrl: 'flags/iran.webp',
  },
  'Tracy Cortez': {
    displayName: 'Tracy Cortez',
    logoUrl: 'flags/united_states.webp',
  },
  'Erin Blanchfield': {
    displayName: 'Erin Blanchfield',
    logoUrl: 'flags/united_states.webp',
  },
  'Roman Kopylov': {
    displayName: 'Roman Kopylov',
    logoUrl: 'flags/russia.webp',
  },
  'Gregory Rodrigues': {
    displayName: 'Gregory Rodrigues',
    logoUrl: 'flags/brazil.webp',
  },
  'Jack Della Maddalena': {
    displayName: 'Jack Della Maddalena',
    logoUrl: 'flags/australia.webp',
  },
  'Islam Makhachev': {
    displayName: 'Islam Makhachev',
    logoUrl: 'flags/russia.webp',
  },
  'Valentina Shevchenko': {
    displayName: 'Valentina Shevchenko',
    logoUrl: 'flags/kyrgyzstan.webp',
  },
  'Zhang Weili': {
    displayName: 'Zhang Weili',
    logoUrl: 'flags/china.webp',
  },
  'Sean Brady': {
    displayName: 'Sean Brady',
    logoUrl: 'flags/united_states.webp',
  },
  'Michael Morales': {
    displayName: 'Michael Morales',
    logoUrl: 'flags/ecuador.webp',
  },
  'Leon Edwards': {
    displayName: 'Leon Edwards',
    logoUrl: 'flags/england.webp',
  },
  'Carlos Prates': {
    displayName: 'Carlos Prates',
    logoUrl: 'flags/brazil.webp',
  },
  'Baisangur Susurkaev': {
    displayName: 'Baisangur Susurkaev',
    logoUrl: 'flags/russia.webp',
  },
  'Eric McConico': {
    displayName: 'Eric McConico',
    logoUrl: 'flags/united_states.webp',
  },
  'Bo Nickal': {
    displayName: 'Bo Nickal',
    logoUrl: 'flags/united_states.webp',
  },
  'Rodolfo Vieira': {
    displayName: 'Rodolfo Vieira',
    logoUrl: 'flags/brazil.webp',
  },
  'Viacheslav Borshchev': {
    displayName: 'Viacheslav Borshchev',
    logoUrl: 'flags/russia.webp',
  },
  'Matheus Camilo': {
    displayName: 'Matheus Camilo',
    logoUrl: 'flags/brazil.webp',
  },
  'Arman Tsarukyan': {
    displayName: 'Arman Tsarukyan',
    logoUrl: 'flags/armenia.webp',
  },
  'Dan Hooker': {
    displayName: 'Dan Hooker',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Belal Muhammad': {
    displayName: 'Belal Muhammad',
    logoUrl: 'flags/palestine.webp',
  },
  'Ian Machado Garry': {
    displayName: 'Ian Machado Garry',
    logoUrl: 'flags/ireland.webp',
  },
  'Volkan Oezdemir': {
    displayName: 'Volkan Oezdemir',
    logoUrl: 'flags/switzerland.webp',
  },
  'Alonzo Menifield': {
    displayName: 'Alonzo Menifield',
    logoUrl: 'flags/united_states.webp',
  },
  'Jack Hermansson': {
    displayName: 'Jack Hermansson',
    logoUrl: 'flags/norway.webp',
  },
  'Myktybek Orolbai': {
    displayName: 'Myktybek Orolbai',
    logoUrl: 'flags/kyrgyzstan.webp',
  },
  'Serghei Spivac': {
    displayName: 'Serghei Spivac',
    logoUrl: 'flags/moldova.webp',
  },
  'Shamil Gaziev': {
    displayName: 'Shamil Gaziev',
    logoUrl: 'flags/bahrain.webp',
  },
  'Alex Perez': {
    displayName: 'Alex Perez',
    logoUrl: 'flags/united_states.webp',
  },
  'Asu Almabayev': {
    displayName: 'Asu Almabayev',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Bogdan Grad': {
    displayName: 'Bogdan Grad',
    logoUrl: 'flags/austria.webp',
  },
  'Luke Riley': {
    displayName: 'Luke Riley',
    logoUrl: 'flags/england.webp',
  },
  'Abdul-Rakhman Yakhyaev': {
    displayName: 'Abdul-Rakhman Yakhyaev',
    logoUrl: 'flags/russia.webp',
  },
  'Rafael Cerqueira': {
    displayName: 'Rafael Cerqueira',
    logoUrl: 'flags/brazil.webp',
  },
  'Tagir Ulanbekov': {
    displayName: 'Tagir Ulanbekov',
    logoUrl: 'flags/russia.webp',
  },
  'Kyoji Horiguchi': {
    displayName: 'Kyoji Horiguchi',
    logoUrl: 'flags/japan.webp',
  },
  'Bekzat Almakhan': {
    displayName: 'Bekzat Almakhan',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Aleksandre Topuria': {
    displayName: 'Aleksandre Topuria',
    logoUrl: 'flags/georgia.webp',
  },
  'Ismail Naurdiev': {
    displayName: 'Ismail Naurdiev',
    logoUrl: 'flags/austria.webp',
  },
  'Ryan Loder': {
    displayName: 'Ryan Loder',
    logoUrl: 'flags/united_states.webp',
  },
  'Nurullo Aliev': {
    displayName: 'Nurullo Aliev',
    logoUrl: 'flags/tajikistan.webp',
  },
  'Shaqueme Rock': {
    displayName: 'Shaqueme Rock',
    logoUrl: 'flags/england.webp',
  },
  'Nicolas Dalby': {
    displayName: 'Nicolas Dalby',
    logoUrl: 'flags/denmark.webp',
  },
  'Saygid Izagakhmaev': {
    displayName: 'Saygid Izagakhmaev',
    logoUrl: 'flags/russia.webp',
  },
  'Marek Bujło': {
    displayName: 'Marek Bujło',
    logoUrl: 'flags/poland.webp',
  },
  'Denzel Freeman': {
    displayName: 'Denzel Freeman',
    logoUrl: 'flags/united_states.webp',
  },
  'Tatsuro Taira': {
    displayName: 'Tatsuro Taira',
    logoUrl: 'flags/japan.webp',
  },
  'Brandon Moreno': {
    displayName: 'Brandon Moreno',
    logoUrl: 'flags/mexico.webp',
  },
  'Edson Barboza': {
    displayName: 'Edson Barboza',
    logoUrl: 'flags/brazil.webp',
  },
  'Jalin Turner': {
    displayName: 'Jalin Turner',
    logoUrl: 'flags/united_states.webp',
  },
  'Muhammad Naimov': {
    displayName: 'Muhammad Naimov',
    logoUrl: 'flags/tajikistan.webp',
  },
  'Mairon Santos': {
    displayName: 'Mairon Santos',
    logoUrl: 'flags/brazil.webp',
  },
  'Marvin Vettori': {
    displayName: 'Marvin Vettori',
    logoUrl: 'flags/italy.webp',
  },
  'Brunno Ferreira': {
    displayName: 'Brunno Ferreira',
    logoUrl: 'flags/brazil.webp',
  },
  'Ibo Aslan': {
    displayName: 'Ibo Aslan',
    logoUrl: 'flags/turkey.webp',
  },
  'Iwo Baraniewski': {
    displayName: 'Iwo Baraniewski',
    logoUrl: 'flags/poland.webp',
  },
  'Manuel Torres': {
    displayName: 'Manuel Torres',
    logoUrl: 'flags/mexico.webp',
  },
  'Grant Dawson': {
    displayName: 'Grant Dawson',
    logoUrl: 'flags/united_states.webp',
  },
  'Terrance McKinney': {
    displayName: 'Terrance McKinney',
    logoUrl: 'flags/united_states.webp',
  },
  'Chris Duncan': {
    displayName: 'Chris Duncan',
    logoUrl: 'flags/scotland.webp',
  },
  'Karine Silva': {
    displayName: 'Karine Silva',
    logoUrl: 'flags/brazil.webp',
  },
  'Maycee Barber': {
    displayName: 'Maycee Barber',
    logoUrl: 'flags/united_states.webp',
  },
  'Fares Ziam': {
    displayName: 'Fares Ziam',
    logoUrl: 'flags/france.webp',
  },
  'Nazim Sadykhov': {
    displayName: 'Nazim Sadykhov',
    logoUrl: 'flags/azerbaijan.webp',
  },
  'Petr Yan': {
    displayName: 'Petr Yan',
    logoUrl: 'flags/russia.webp',
  },
  'Merab Dvalishvili': {
    displayName: 'Merab Dvalishvili',
    logoUrl: 'flags/georgia.webp',
  },
  'Joshua Van': {
    displayName: 'Joshua Van',
    logoUrl: 'flags/myanmar.webp',
  },
  'Alexandre Pantoja': {
    displayName: 'Alexandre Pantoja',
    logoUrl: 'flags/brazil.webp',
  },
  'Payton Talbott': {
    displayName: 'Payton Talbott',
    logoUrl: 'flags/united_states.webp',
  },
  'Henry Cejudo': {
    displayName: 'Henry Cejudo',
    logoUrl: 'flags/united_states.webp',
  },
  'Bogdan Guskov': {
    displayName: 'Bogdan Guskov',
    logoUrl: 'flags/uzbekistan.webp',
  },
  'Jan Blachowicz': {
    displayName: 'Jan Blachowicz',
    logoUrl: 'flags/poland.webp',
  },
  'Jamey-Lyn Horth': {
    displayName: 'Jamey-Lyn Horth',
    logoUrl: 'flags/canada.webp',
  },
  'Tereza Bleda': {
    displayName: 'Tereza Bleda',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Sean Sharaf': {
    displayName: 'Sean Sharaf',
    logoUrl: 'flags/united_states.webp',
  },
  'Steven Asplund': {
    displayName: 'Steven Asplund',
    logoUrl: 'flags/united_states.webp',
  },
  'Amanda Lemos': {
    displayName: 'Amanda Lemos',
    logoUrl: 'flags/brazil.webp',
  },
  'Gillian Robertson': {
    displayName: 'Gillian Robertson',
    logoUrl: 'flags/canada.webp',
  },
  'Melsik Baghdasaryan': {
    displayName: 'Melsik Baghdasaryan',
    logoUrl: 'flags/armenia.webp',
  },
  'Joanderson Brito': {
    displayName: 'Joanderson Brito',
    logoUrl: 'flags/brazil.webp',
  },
  'Neil Magny': {
    displayName: 'Neil Magny',
    logoUrl: 'flags/united_states.webp',
  },
  'Yaroslav Amosov': {
    displayName: 'Yaroslav Amosov',
    logoUrl: 'flags/ukraine.webp',
  },
  'Guilherme Pat': {
    displayName: 'Guilherme Pat',
    logoUrl: 'flags/brazil.webp',
  },
  'Allen Frye': {
    displayName: 'Allen Frye',
    logoUrl: 'flags/united_states.webp',
  },
  'Morgan Charriere': {
    displayName: 'Morgan Charriere',
    logoUrl: 'flags/france.webp',
  },
  'Melquizael Costa': {
    displayName: 'Melquizael Costa',
    logoUrl: 'flags/brazil.webp',
  },
  'Manel Kape': {
    displayName: 'Manel Kape',
    logoUrl: 'flags/portugal.webp',
  },
  'Brandon Royval': {
    displayName: 'Brandon Royval',
    logoUrl: 'flags/united_states.webp',
  },
  'Marcus Buchecha': {
    displayName: 'Marcus Buchecha',
    logoUrl: 'flags/brazil.webp',
  },
  'Kennedy Nzechukwu': {
    displayName: 'Kennedy Nzechukwu',
    logoUrl: 'flags/united_states.webp',
  },
  'Giga Chikadze': {
    displayName: 'Giga Chikadze',
    logoUrl: 'flags/georgia.webp',
  },
  'Kevin Vallejos': {
    displayName: 'Kevin Vallejos',
    logoUrl: 'flags/argentina.webp',
  },
  'Cesar Almeida': {
    displayName: 'Cesar Almeida',
    logoUrl: 'flags/brazil.webp',
  },
  'Cezary Oleksiejczuk': {
    displayName: 'Cezary Oleksiejczuk',
    logoUrl: 'flags/poland.webp',
  },
  'Bobby Green': {
    displayName: 'Bobby Green',
    logoUrl: 'flags/united_states.webp',
  },
  'Lance Gibson Jr': {
    displayName: 'Lance Gibson Jr',
    logoUrl: 'flags/canada.webp',
  },
  'Alexander Volkanovski': {
    displayName: 'Alexander Volkanovski',
    logoUrl: 'flags/australia.webp'
  },
  'Amanda Nunes': {
    displayName: 'Amanda Nunes',
    logoUrl: 'flags/brazil.webp'
  },
  'Arnold Allen': {
    displayName: 'Arnold Allen',
    logoUrl: 'flags/united_kingdom.webp'
  },
  'Derrick Lewis': {
    displayName: 'Derrick Lewis',
    logoUrl: 'flags/united_states.webp'
  },
  'Justin Gaethje': {
    displayName: 'Justin Gaethje',
    logoUrl: 'flags/united_states.webp'
  },
  'Kayla Harrison': {
    displayName: 'Kayla Harrison',
    logoUrl: 'flags/united_states.webp'
  },
  'Khamzat Chimaev': {
    displayName: 'Khamzat Chimaev',
    logoUrl: 'flags/uae.webp'
  },
  'Michael Page': {
    displayName: 'Michael Page',
    logoUrl: 'flags/united_kingdom.webp'
  },
  'Nassourdine Imavov': {
    displayName: 'Nassourdine Imavov',
    logoUrl: 'flags/france.webp'
  },
  'Natalia Silva': {
    displayName: 'Natalia Silva',
    logoUrl: 'flags/brazil.webp'
  },
  'Paddy Pimblett': {
    displayName: 'Paddy Pimblett',
    logoUrl: 'flags/united_kingdom.webp'
  },
  'Rose Namajunas': {
    displayName: 'Rose Namajunas',
    logoUrl: 'flags/united_states.webp'
  },
  'Sean Omalley': {
    displayName: 'Sean Omalley',
    logoUrl: 'flags/united_states.webp'
  },
  'Song Yadong': {
    displayName: 'Song Yadong',
    logoUrl: 'flags/china.webp'
  },
  'Waldo Cortes Acosta': {
    displayName: 'Waldo Cortes Acosta',
    logoUrl: 'flags/dominican_republic.webp',
  },
  'Cameron Smotherman': {
    displayName: 'Cameron Smotherman',
    logoUrl: 'flags/united_states.webp',
  },
  'Ricky Turcios': {
    displayName: 'Ricky Turcios',
    logoUrl: 'flags/united_states.webp',
  },
  'Charles Johnson': {
    displayName: 'Charles Johnson',
    logoUrl: 'flags/united_states.webp',
  },
  'Nikita Krylov': {
    displayName: 'Nikita Krylov',
    logoUrl: 'flags/ukraine.webp',
  },
  'Michael Johnson': {
    displayName: 'Michael Johnson',
    logoUrl: 'flags/united_states.webp',
  },
  'Andrey Pulyaev': {
    displayName: 'Andrey Pulyaev',
    logoUrl: 'flags/russia.webp',
  },
  'Ateba Gautier': {
    displayName: 'Ateba Gautier',
    logoUrl: 'flags/united_states.webp',
  },
  'Deiveson Figueiredo': {
    displayName: 'Deiveson Figueiredo',
    logoUrl: 'flags/brazil.webp',
  },
  'Umar Nurmagomedov': {
    displayName: 'Umar Nurmagomedov',
    logoUrl: 'flags/russia.webp',
  },
  'Ty Miller': {
    displayName: 'Ty Miller',
    logoUrl: 'flags/united_states.webp',
  },
  'Adam Fugitt': {
    displayName: 'Adam Fugitt',
    logoUrl: 'flags/united_states.webp',
  },
  'Quillan Salkilld': {
    displayName: 'Quillan Salkilld',
    logoUrl: 'flags/australia.webp',
  },
  'Rongzhu': {
    displayName: 'Rongzhu',
    logoUrl: 'flags/china.webp',
  },
  'Kaan Ofli': {
    displayName: 'Kaan Ofli',
    logoUrl: 'flags/australia.webp',
  },
  'Yizha': {
    displayName: 'Yizha',
    logoUrl: 'flags/china.webp',
  },
  'Tai Tuivasa': {
    displayName: 'Tai Tuivasa',
    logoUrl: 'flags/australia.webp',
  },
  'Tallison Teixeira': {
    displayName: 'Tallison Teixeira',
    logoUrl: 'flags/brazil.webp',
  },
  'Jonathan Micallef': {
    displayName: 'Jonathan Micallef',
    logoUrl: 'flags/australia.webp',
  },
  'Oban Elliott': {
    displayName: 'Oban Elliott',
    logoUrl: 'flags/wales.webp',
  },
  'Rafael Fiziev': {
    displayName: 'Rafael Fiziev',
    logoUrl: 'flags/azerbaijan.webp',
  },
  'Jimmy Crute': {
    displayName: 'Jimmy Crute',
    logoUrl: 'flags/australia.webp',
  },
  'Dustin Jacoby': {
    displayName: 'Dustin Jacoby',
    logoUrl: 'flags/united_states.webp',
  },
  'Junior Tafa': {
    displayName: 'Junior Tafa',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Cam Rowston': {
    displayName: 'Cam Rowston',
    logoUrl: 'flags/australia.webp',
  },
  'Cody Brundage': {
    displayName: 'Cody Brundage',
    logoUrl: 'flags/united_states.webp',
  },
  'Priscila Cachoeira': {
    displayName: 'Priscila Cachoeira',
    logoUrl: 'flags/brazil.webp',
  },
  'Klaudia Sygula': {
    displayName: 'Klaudia Sygula',
    logoUrl: 'flags/poland.webp',
  },
  'Amir Albazi': {
    displayName: 'Amir Albazi',
    logoUrl: 'flags/iraq.webp',
  },
  'Muin Gafurov': {
    displayName: 'Muin Gafurov',
    logoUrl: 'flags/tajikistan.webp',
  },
  'Jakub Wiklacz': {
    displayName: 'Jakub Wiklacz',
    logoUrl: 'flags/poland.webp',
  },
  'Eduarda Moura': {
    displayName: 'Eduarda Moura',
    logoUrl: 'flags/brazil.webp',
  },
  'Wang Cong': {
    displayName: 'Wang Cong',
    logoUrl: 'flags/china.webp',
  },
  'Ketlen Souza': {
    displayName: 'Ketlen Souza',
    logoUrl: 'flags/brazil.webp',
  },
  'Bruna Brasil': {
    displayName: 'Bruna Brasil',
    logoUrl: 'flags/brazil.webp',
  },
  'Marc-Andre Barriault': {
    displayName: 'Marc-Andre Barriault',
    logoUrl: 'flags/canada.webp',
  },
  'Michal Oleksiejczuk': {
    displayName: 'Michal Oleksiejczuk',
    logoUrl: 'flags/poland.webp',
  },
  'Said Nurmagomedov': {
    displayName: 'Said Nurmagomedov',
    logoUrl: 'flags/russia.webp',
  },
  'Javid Basharat': {
    displayName: 'Javid Basharat',
    logoUrl: 'flags/afghanistan.webp',
  },
  'Alex Morono': {
    displayName: 'Alex Morono',
    logoUrl: 'flags/united_states.webp',
  },
  'Daniil Donchenko': {
    displayName: 'Daniil Donchenko',
    logoUrl: 'flags/ukraine.webp',
  },
  'Vinicius Oliveira': {
    displayName: 'Vinicius Oliveira',
    logoUrl: 'flags/brazil.webp',
  },
  'Mario Bautista': {
    displayName: 'Mario Bautista',
    logoUrl: 'flags/united_states.webp',
  },
  'Jean Matsumoto': {
    displayName: 'Jean Matsumoto',
    logoUrl: 'flags/brazil.webp',
  },
  'Farid Basharat': {
    displayName: 'Farid Basharat',
    logoUrl: 'flags/afghanistan.webp',
  },
  'John Garza': {
    displayName: 'John Garza',
    logoUrl: 'flags/united_states.webp',
  },
  'Rizvan Kuniev': {
    displayName: 'Rizvan Kuniev',
    logoUrl: 'flags/russia.webp',
  },
  'Jailton Almeida': {
    displayName: 'Jailton Almeida',
    logoUrl: 'flags/brazil.webp',
  },
  'Julius Walker': {
    displayName: 'Julius Walker',
    logoUrl: 'flags/united_states.webp',
  },
  'Keiichiro Nakamura': {
    displayName: 'Keiichiro Nakamura',
    logoUrl: 'flags/japan.webp'
  },
  'Sebastian Szalay': {
    displayName: 'Sebastian Szalay',
    logoUrl: 'flags/hungary.webp'
  },
  'Kim Sang wook': {
    displayName: 'Kim Sang wook',
    logoUrl: 'flags/south_korea.webp'
  },
  'Dom Mar Fan': {
    displayName: 'Dom Mar Fan',
    logoUrl: 'flags/australia.webp'
  },
  'Sulangrangbo': {
    displayName: 'Sulangrangbo',
    logoUrl: 'flags/china.webp'
  },
  'Lawrence Lui': {
    displayName: 'Lawrence Lui',
    logoUrl: 'flags/new_zealand.webp'
  },
  'Aaron Tau': {
    displayName: 'Aaron Tau',
    logoUrl: 'flags/new_zealand.webp'
  },
  'Namsrai Batbayar': {
    displayName: 'Namsrai Batbayar',
    logoUrl: 'flags/mongolia.webp'
  },
  'Jamie Mullarkey': {
    displayName: 'Jamie Mullarkey',
    logoUrl: 'flags/australia.webp'
  },
  'Jacob Malkoun': {
    displayName: 'Jacob Malkoun',
    logoUrl: 'flags/australia.webp'
  },
  'Torrez Finney': {
    displayName: 'Torrez Finney',
    logoUrl: 'flags/united_states.webp'
  },
  'Carlos Leal': {
    displayName: 'Carlos Leal',
    logoUrl: 'flags/brazil.webp',
  },
  'Chidi Njokuani': {
    displayName: 'Chidi Njokuani',
    logoUrl: 'flags/united_states.webp',
  },
  'Dan Ige': {
    displayName: 'Dan Ige',
    logoUrl: 'flags/united_states.webp',
  },
  'Geoff Neal': {
    displayName: 'Geoff Neal',
    logoUrl: 'flags/united_states.webp',
  },
  'Sean Strickland': {
    displayName: 'Sean Strickland',
    logoUrl: 'flags/united_states.webp',
  },
  'Anthony Hernandez': {
    displayName: 'Anthony Hernandez',
    logoUrl: 'flags/united_states.webp',
  },
  'Seok Hyeon Ko': {
    displayName: 'Seok Hyeon Ko',
    logoUrl: 'flags/south_korea.webp',
  },
  'Jacobe Smith': {
    displayName: 'Jacobe Smith',
    logoUrl: 'flags/united_states.webp',
  },
  'Ode Osbourne': {
    displayName: 'Ode Osbourne',
    logoUrl: 'flags/jamaica.webp',
  },
  'Alibi Idiris': {
    displayName: 'Alibi Idiris',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Michel Pereira': {
    displayName: 'Michel Pereira',
    logoUrl: 'flags/brazil.webp',
  },
  'Zach Reese': {
    displayName: 'Zach Reese',
    logoUrl: 'flags/united_states.webp',
  },
  'Juliana Miller': {
    displayName: 'Juliana Miller',
    logoUrl: 'flags/united_states.webp',
  },
  'Carli Judice': {
    displayName: 'Carli Judice',
    logoUrl: 'flags/united_states.webp',
  },
  'Luis Gurule': {
    displayName: 'Luis Gurule',
    logoUrl: 'flags/united_states.webp',
  },
  'Alden Coria': {
    displayName: 'Alden Coria',
    logoUrl: 'flags/united_states.webp',
  },
  'Nora Cornolle': {
    displayName: 'Nora Cornolle',
    logoUrl: 'flags/france.webp',
  },
  'Joselyne Edwards': {
    displayName: 'Joselyne Edwards',
    logoUrl: 'flags/panama.webp',
  },
  'Punahele Soriano': {
    displayName: 'Punahele Soriano',
    logoUrl: 'flags/united_states.webp',
  },
  'Ramiz Brahimaj': {
    displayName: 'Ramiz Brahimaj',
    logoUrl: 'flags/united_states.webp',
  },
  'Jordan Leavitt': {
    displayName: 'Jordan Leavitt',
    logoUrl: 'flags/united_states.webp',
  },
  'Jean Paul Lebosnoyani': {
    displayName: 'Jean Paul Lebosnoyani',
    logoUrl: 'flags/united_states.webp',
  },
  'Charles Oliveira': {
    displayName: 'Charles Oliveira',
    logoUrl: 'flags/brazil.webp',
  },
  'Max Holloway': {
    displayName: 'Max Holloway',
    logoUrl: 'flags/united_states.webp',
  },
  'Long Xiao': {
    displayName: 'Long Xiao',
    logoUrl: 'flags/china.webp',
  },
  'Cody Garbrandt': {
    displayName: 'Cody Garbrandt',
    logoUrl: 'flags/united_states.webp',
  },
  'Reinier de Ridder': {
    displayName: 'Reinier de Ridder',
    logoUrl: 'flags/netherlands.webp',
  },
  'Raul Rosas Jr.': {
    displayName: 'Raul Rosas Jr.',
    logoUrl: 'flags/mexico.webp',
  },
  'Drew Dober': {
    displayName: 'Drew Dober',
    logoUrl: 'flags/united_states.webp',
  },
  'Sumudaerji': {
    displayName: 'Sumudaerji',
    logoUrl: 'flags/china.webp',
  },
  'Jesus Aguilar': {
    displayName: 'Jesus Aguilar',
    logoUrl: 'flags/mexico.webp',
  },
  'Alberto Montes': {
    displayName: 'Alberto Montes',
    logoUrl: 'flags/venezuela.webp',
  },
  'Nyamjargal Tumendemberel': {
    displayName: 'Nyamjargal Tumendemberel',
    logoUrl: 'flags/mongolia.webp',
  },
  'Gaston Bolanos': {
    displayName: 'Gaston Bolanos',
    logoUrl: 'flags/peru.webp',
  },
  'Jeong Yeong Lee': {
    displayName: 'Jeong Yeong Lee',
    logoUrl: 'flags/south_korea.webp',
  },
  'Diyar Nurgozhay': {
    displayName: 'Diyar Nurgozhay',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Rafael Tobias': {
    displayName: 'Rafael Tobias',
    logoUrl: 'flags/brazil.webp',
  },
  'Rodolfo Bellato': {
    displayName: 'Rodolfo Bellato',
    logoUrl: 'flags/brazil.webp',
  },
  'Luke Fernandez': {
    displayName: 'Luke Fernandez',
    logoUrl: 'flags/united_states.webp',
  },
  'Bia Mesquita': {
    displayName: 'Bia Mesquita',
    logoUrl: 'flags/brazil.webp',
  },
  'Hecher Sosa': {
    displayName: 'Hecher Sosa',
    logoUrl: 'flags/spain.webp',
  },
  'Luan Lacerda': {
    displayName: 'Luan Lacerda',
    logoUrl: 'flags/brazil.webp',
  },
  'Manoel Sousa': {
    displayName: 'Manoel Sousa',
    logoUrl: 'flags/brazil.webp',
  },
  'Eryk Anders': {
    displayName: 'Eryk Anders',
    logoUrl: 'flags/united_states.webp',
  },
  'Brad Tavares': {
    displayName: 'Brad Tavares',
    logoUrl: 'flags/united_states.webp',
  },
  'Chris Curtis': {
    displayName: 'Chris Curtis',
    logoUrl: 'flags/united_states.webp',
  },
  'Bruno Silva': {
    displayName: 'Bruno Silva',
    logoUrl: 'flags/brazil.webp',
  },
  'Vitor Petrino': {
    displayName: 'Vitor Petrino',
    logoUrl: 'flags/brazil.webp',
  },
  'Marwan Rahiki': {
    displayName: 'Marwan Rahiki',
    logoUrl: 'flags/france.webp',
  },
  'Jose Delgado': {
    displayName: 'Jose Delgado',
    logoUrl: 'flags/united_states.webp',
  },
  'Andre Fili': {
    displayName: 'Andre Fili',
    logoUrl: 'flags/united_states.webp',
  },
  'Ion Cutelaba': {
    displayName: 'Ion Cutelaba',
    logoUrl: 'flags/moldova.webp',
  },
  'Josh Emmett': {
    displayName: 'Josh Emmett',
    logoUrl: 'flags/united_states.webp',
  },
  'Piera Rodriguez': {
    displayName: 'Piera Rodriguez',
    logoUrl: 'flags/venezuela.webp',
  },
  'Su Young You': {
    displayName: 'Su Young You',
    logoUrl: 'flags/south_korea.webp',
  },
  'Elijah Smith': {
    displayName: 'Elijah Smith',
    logoUrl: 'flags/united_states.webp',
  },
  'Lerone Murphy': {
    displayName: 'Lerone Murphy',
    logoUrl: 'flags/england.webp',
  },
  'Movsar Evloev': {
    displayName: 'Movsar Evloev',
    logoUrl: 'flags/russia.webp',
  },
  'Michael Aswell': {
    displayName: 'Michael Aswell',
    logoUrl: 'flags/united_states.webp',
  },
  'Roman Dolidze': {
    displayName: 'Roman Dolidze',
    logoUrl: 'flags/georgia.webp',
  },
  'Danny Silva': {
    displayName: 'Danny Silva',
    logoUrl: 'flags/united_states.webp',
  },
  'Kurtis Campbell': {
    displayName: 'Kurtis Campbell',
    logoUrl: 'flags/united_states.webp',
  },
  'Felipe Franco': {
    displayName: 'Felipe Franco',
    logoUrl: 'flags/brazil.webp',
  },
  'Mario Pinto': {
    displayName: 'Mario Pinto',
    logoUrl: 'flags/portugal.webp',
  },
  'Brando Pericic': {
    displayName: 'Brando Pericic',
    logoUrl: 'flags/croatia.webp',
  },
  'Louie Sutherland': {
    displayName: 'Louie Sutherland',
    logoUrl: 'flags/scotland.webp',
  },
  'Shem Rock': {
    displayName: 'Shem Rock',
    logoUrl: 'flags/england.webp',
  },
  'Abdul-Kareem Al-Selwady': {
    displayName: 'Abdul-Kareem Al-Selwady',
    logoUrl: 'flags/palestine.webp',
  },
  'Austen Lane': {
    displayName: 'Austen Lane',
    logoUrl: 'flags/united_states.webp',
  },
  'Losene Keita': {
    displayName: 'Losene Keita',
    logoUrl: 'flags/guinea.webp',
  },
  'Nathaniel Wood': {
    displayName: 'Nathaniel Wood',
    logoUrl: 'flags/england.webp',
  },
  'Antonio Trocoli': {
    displayName: 'Antonio Trocoli',
    logoUrl: 'flags/brazil.webp',
  },
  'Mantas Kondratavicius': {
    displayName: 'Mantas Kondratavicius',
    logoUrl: 'flags/lithuania.webp',
  },
  'Luana Carolina': {
    displayName: 'Luana Carolina',
    logoUrl: 'flags/brazil.webp',
  },
  'Melissa Mullins': {
    displayName: 'Melissa Mullins',
    logoUrl: 'flags/england.webp',
  },
  'Ravena Oliveira': {
    displayName: 'Ravena Oliveira',
    logoUrl: 'flags/brazil.webp',
  },
  'Shanelle Dyer': {
    displayName: 'Shanelle Dyer',
    logoUrl: 'flags/england.webp',
  },
  'Ilia Topuria': {
    displayName: 'Ilia Topuria',
    logoUrl: 'flags/spain.webp',
  },
  'Ciryl Gane': {
    displayName: 'Ciryl Gane',
    logoUrl: 'flags/france.webp',
  },
  'Alex Pereira': {
    displayName: 'Alex Pereira',
    logoUrl: 'flags/brazil.webp',
  },
  'Michael Chandler': {
    displayName: 'Michael Chandler',
    logoUrl: 'flags/united_states.webp',
  },
  'Aiemann Zahabi': {
    displayName: 'Aiemann Zahabi',
    logoUrl: 'flags/canada.webp',
  },
  'Joe Pyfer': {
    displayName: 'Joe Pyfer',
    logoUrl: 'flags/united_states.webp',
  },
  'Israel Adesanya': {
    displayName: 'Israel Adesanya',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Alexa Grasso': {
    displayName: 'Alexa Grasso',
    logoUrl: 'flags/mexico.webp',
  },
  'Lerryan Douglas': {
    displayName: 'Lerryan Douglas',
    logoUrl: 'flags/brazil.webp',
  },
  'Julian Erosa': {
    displayName: 'Julian Erosa',
    logoUrl: 'flags/united_states.webp',
  },
  'Yousri Belgaroui': {
    displayName: 'Yousri Belgaroui',
    logoUrl: 'flags/tunisia.webp',
  },
  'Mansur Abdul-Malik': {
    displayName: 'Mansur Abdul-Malik',
    logoUrl: 'flags/united_states.webp',
  },
  'Kyle Nelson': {
    displayName: 'Kyle Nelson',
    logoUrl: 'flags/canada.webp',
  },
  'Tofiq Musayev': {
    displayName: 'Tofiq Musayev',
    logoUrl: 'flags/azerbaijan.webp',
  },
  'Ignacio Bahamondes': {
    displayName: 'Ignacio Bahamondes',
    logoUrl: 'flags/chile.webp',
  },
  'Lance Gibson Jr.': {
    displayName: 'Lance Gibson Jr.',
    logoUrl: 'flags/canada.webp',
  },
  'Chase Hooper': {
    displayName: 'Chase Hooper',
    logoUrl: 'flags/united_states.webp',
  },
  'Tyrell Fortune': {
    displayName: 'Tyrell Fortune',
    logoUrl: 'flags/united_states.webp',
  },
  'Gabriella Fernandes': {
    displayName: 'Gabriella Fernandes',
    logoUrl: 'flags/brazil.webp',
  },
  "Casey O'Neill": {
    displayName: "Casey O'Neill",
    logoUrl: 'flags/australia.webp',
  },
  'Alexia Thainara': {
    displayName: 'Alexia Thainara',
    logoUrl: 'flags/brazil.webp',
  },
  'Bruno Lopes': {
    displayName: 'Bruno Lopes',
    logoUrl: 'flags/brazil.webp',
  },
  'Navajo Stirling': {
    displayName: 'Navajo Stirling',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Melissa Gatto': {
    displayName: 'Melissa Gatto',
    logoUrl: 'flags/brazil.webp',
  },
  'Dione Barbosa': {
    displayName: 'Dione Barbosa',
    logoUrl: 'flags/brazil.webp',
  },
  'Tresean Gore': {
    displayName: 'Tresean Gore',
    logoUrl: 'flags/united_states.webp',
  },
  'Azamat Bekoev': {
    displayName: 'Azamat Bekoev',
    logoUrl: 'flags/russia.webp',
  },
  'Hailey Cowan': {
    displayName: 'Hailey Cowan',
    logoUrl: 'flags/united_states.webp',
  },
  'Alice Pereira': {
    displayName: 'Alice Pereira',
    logoUrl: 'flags/brazil.webp',
  },
  'Darrius Flowers': {
    displayName: 'Darrius Flowers',
    logoUrl: 'flags/united_states.webp',
  },
  'Lando Vannata': {
    displayName: 'Lando Vannata',
    logoUrl: 'flags/united_states.webp',
  },
  'Stewart Nicoll': {
    displayName: 'Stewart Nicoll',
    logoUrl: 'flags/australia.webp',
  },
  'Alessandro Costa': {
    displayName: 'Alessandro Costa',
    logoUrl: 'flags/brazil.webp',
  },
  'Thomas Petersen': {
    displayName: 'Thomas Petersen',
    logoUrl: 'flags/united_states.webp',
  },
  'Guilherme Faria': {
    displayName: 'Guilherme Faria',
    logoUrl: 'flags/brazil.webp',
  },
  'Jose Delano': {
    displayName: 'Jose Delano',
    logoUrl: 'flags/brazil.webp',
  },
  'Manolo Zecchini': {
    displayName: 'Manolo Zecchini',
    logoUrl: 'flags/italy.webp',
  },
  'Tommy McMillen': {
    displayName: 'Tommy McMillen',
    logoUrl: 'flags/united_states.webp',
  },
  'Rafael Estevam': {
    displayName: 'Rafael Estevam',
    logoUrl: 'flags/brazil.webp',
  },
  'Ethyn Ewing': {
    displayName: 'Ethyn Ewing',
    logoUrl: 'flags/united_states.webp',
  },
  'Abdul Rakhman Yakhyaev': {
    displayName: 'Abdul Rakhman Yakhyaev',
    logoUrl: 'flags/russia.webp',
  },
  'Tabatha Ricci': {
    displayName: 'Tabatha Ricci',
    logoUrl: 'flags/brazil.webp',
  },
  'Virna Jandiroba': {
    displayName: 'Virna Jandiroba',
    logoUrl: 'flags/brazil.webp',
  },
  'Renato Moicano': {
    displayName: 'Renato Moicano',
    logoUrl: 'flags/brazil.webp',
  },
  'Aaron Pico': {
    displayName: 'Aaron Pico',
    logoUrl: 'flags/united_states.webp',
  },
  'Azamat Murzakanov': {
    displayName: 'Azamat Murzakanov',
    logoUrl: 'flags/russia.webp',
  },
  'Carlos Ulberg': {
    displayName: 'Carlos Ulberg',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Cub Swanson': {
    displayName: 'Cub Swanson',
    logoUrl: 'flags/united_states.webp',
  },
  'Curtis Blaydes': {
    displayName: 'Curtis Blaydes',
    logoUrl: 'flags/united_states.webp',
  },
  'Dominick Reyes': {
    displayName: 'Dominick Reyes',
    logoUrl: 'flags/united_states.webp',
  },
  'Esteban Ribovics': {
    displayName: 'Esteban Ribovics',
    logoUrl: 'flags/argentina.webp',
  },
  'Francisco Prado': {
    displayName: 'Francisco Prado',
    logoUrl: 'flags/argentina.webp',
  },
  'Jiri Prochazka': {
    displayName: 'Jiri Prochazka',
    logoUrl: 'flags/czech_republic.webp',
  },
  'Johnny Walker': {
    displayName: 'Johnny Walker',
    logoUrl: 'flags/brazil.webp',
  },
  'Kevin Holland': {
    displayName: 'Kevin Holland',
    logoUrl: 'flags/united_states.webp',
  },
  'Lupita Godinez': {
    displayName: 'Lupita Godinez',
    logoUrl: 'flags/mexico.webp',
  },
  'Marquel Mederos': {
    displayName: 'Marquel Mederos',
    logoUrl: 'flags/cuba.webp',
  },
  'Mateusz Gamrot': {
    displayName: 'Mateusz Gamrot',
    logoUrl: 'flags/poland.webp',
  },
  'Nate Landwehr': {
    displayName: 'Nate Landwehr',
    logoUrl: 'flags/united_states.webp',
  },
  'Patricio Pitbull': {
    displayName: 'Patricio Pitbull',
    logoUrl: 'flags/brazil.webp',
  },
  'Paulo Costa': {
    displayName: 'Paulo Costa',
    logoUrl: 'flags/brazil.webp',
  },
  'Tatiana Suarez': {
    displayName: 'Tatiana Suarez',
    logoUrl: 'flags/united_states.webp',
  },
  'Vicente Luque': {
    displayName: 'Vicente Luque',
    logoUrl: 'flags/brazil.webp',
  },
  'Aljamain Sterling': {
    displayName: 'Aljamain Sterling',
    logoUrl: 'flags/united_states.webp',
  },
  'Charles Jourdain': {
    displayName: 'Charles Jourdain',
    logoUrl: 'flags/canada.webp',
  },
  'Daria Zhelezniakova': {
    displayName: 'Daria Zhelezniakova',
    logoUrl: 'flags/russia.webp',
  },
  'Davey Grant': {
    displayName: 'Davey Grant',
    logoUrl: 'flags/england.webp',
  },
  'Dennis Buzukja': {
    displayName: 'Dennis Buzukja',
    logoUrl: 'flags/united_states.webp',
  },
  'Gauge Young': {
    displayName: 'Gauge Young',
    logoUrl: 'flags/united_states.webp',
  },
  'Gilbert Burns': {
    displayName: 'Gilbert Burns',
    logoUrl: 'flags/brazil.webp',
  },
  'Gokhan Saricam': {
    displayName: 'Gokhan Saricam',
    logoUrl: 'flags/turkey.webp',
  },
  'Jafel Filho': {
    displayName: 'Jafel Filho',
    logoUrl: 'flags/brazil.webp',
  },
  'Jai Herbert': {
    displayName: 'Jai Herbert',
    logoUrl: 'flags/england.webp',
  },
  'Jamie Siraj': {
    displayName: 'Jamie Siraj',
    logoUrl: 'flags/canada.webp',
  },
  'Jasmine Jasudavicius': {
    displayName: 'Jasmine Jasudavicius',
    logoUrl: 'flags/canada.webp',
  },
  'JJ Aldrich': {
    displayName: 'JJ Aldrich',
    logoUrl: 'flags/united_states.webp',
  },
  'John Castaneda': {
    displayName: 'John Castaneda',
    logoUrl: 'flags/united_states.webp',
  },
  'John Yannis': {
    displayName: 'John Yannis',
    logoUrl: 'flags/united_states.webp',
  },
  'Julia Polastri': {
    displayName: 'Julia Polastri',
    logoUrl: 'flags/brazil.webp',
  },
  'Julien Leblanc': {
    displayName: 'Julien Leblanc',
    logoUrl: 'flags/canada.webp',
  },
  'Juan Martinetti': {
    displayName: 'Juan Martinetti',
    logoUrl: 'flags/ecuador.webp',
  },
  'Kyler Phillips': {
    displayName: 'Kyler Phillips',
    logoUrl: 'flags/united_states.webp',
  },
  'Lucas Rocha': {
    displayName: 'Lucas Rocha',
    logoUrl: 'flags/brazil.webp',
  },
  'Mandel Nallo': {
    displayName: 'Mandel Nallo',
    logoUrl: 'flags/canada.webp',
  },
  'Mark Vologdin': {
    displayName: 'Mark Vologdin',
    logoUrl: 'flags/australia.webp',
  },
  'Max Griffin': {
    displayName: 'Max Griffin',
    logoUrl: 'flags/united_states.webp',
  },
  'Michelle Montague': {
    displayName: 'Michelle Montague',
    logoUrl: 'flags/new_zealand.webp',
  },
  'Mike Malott': {
    displayName: 'Mike Malott',
    logoUrl: 'flags/canada.webp',
  },
  'Mitch Raposo': {
    displayName: 'Mitch Raposo',
    logoUrl: 'flags/united_states.webp',
  },
  'Montel Jackson': {
    displayName: 'Montel Jackson',
    logoUrl: 'flags/united_states.webp',
  },
  'Ryan Spann': {
    displayName: 'Ryan Spann',
    logoUrl: 'flags/united_states.webp',
  },
  'Tanner Boser': {
    displayName: 'Tanner Boser',
    logoUrl: 'flags/canada.webp',
  },
  'Thiago Moises': {
    displayName: 'Thiago Moises',
    logoUrl: 'flags/brazil.webp',
  },
  'Victor Valenzuela': {
    displayName: 'Victor Valenzuela',
    logoUrl: 'flags/united_states.webp',
  },
  'Youssef Zalal': {
    displayName: 'Youssef Zalal',
    logoUrl: 'flags/morocco.webp',
  },
  'Ben Johnston': {
    displayName: 'Ben Johnston',
    logoUrl: 'flags/australia.webp',
  },
  'Colby Thicknesse': {
    displayName: 'Colby Thicknesse',
    logoUrl: 'flags/australia.webp',
  },
  'Kody Steele': {
    displayName: 'Kody Steele',
    logoUrl: 'flags/united_states.webp',
  },
  'Robert Bryczek': {
    displayName: 'Robert Bryczek',
    logoUrl: 'flags/poland.webp',
  },
  'Steve Erceg': {
    displayName: 'Steve Erceg',
    logoUrl: 'flags/australia.webp',
  },
  'Tim Elliott': {
    displayName: 'Tim Elliott',
    logoUrl: 'flags/united_states.webp',
  },
  'Vince Morales': {
    displayName: 'Vince Morales',
    logoUrl: 'flags/united_states.webp',
  },
  'Wes Schultz': {
    displayName: 'Wes Schultz',
    logoUrl: 'flags/united_states.webp',
  },
  'Ozzy Diaz': {
    displayName: 'Ozzy Diaz',
    logoUrl: 'flags/united_states.webp',
  },
  'Ateba Gautier': {
    displayName: 'Ateba Gautier',
    logoUrl: 'flags/france.webp',
  },
  'Djorden Santos': {
    displayName: 'Djorden Santos',
    logoUrl: 'flags/brazil.webp',
  },
  'Baisangur Susurkaev': {
    displayName: 'Baisangur Susurkaev',
    logoUrl: 'flags/russia.webp',
  },
  'Jose Ochoa': {
    displayName: 'Jose Ochoa',
    logoUrl: 'flags/peru.webp',
  },
  'Clayton Carpenter': {
    displayName: 'Clayton Carpenter',
    logoUrl: 'flags/united_states.webp',
  },
  'Jared Gordon': {
    displayName: 'Jared Gordon',
    logoUrl: 'flags/united_states.webp',
  },
  'Jim Miller': {
    displayName: 'Jim Miller',
    logoUrl: 'flags/united_states.webp',
  },
  'Mateusz Rebecki': {
    displayName: 'Mateusz Rebecki',
    logoUrl: 'flags/poland.webp',
  },
  'Grant Dawson': {
    displayName: 'Grant Dawson',
    logoUrl: 'flags/united_states.webp',
  },
  'Yaroslav Amosov': {
    displayName: 'Yaroslav Amosov',
    logoUrl: 'flags/ukraine.webp',
  },
  'Joel Alvarez': {
    displayName: 'Joel Alvarez',
    logoUrl: 'flags/spain.webp',
  },
  'Jeremy Stephens': {
    displayName: 'Jeremy Stephens',
    logoUrl: 'flags/united_states.webp',
  },
  'King Green': {
    displayName: 'King Green',
    logoUrl: 'flags/united_states.webp',
  },
  'Joaquin Buckley': {
    displayName: 'Joaquin Buckley',
    logoUrl: 'flags/united_states.webp',
  },
  'Sean Brady': {
    displayName: 'Sean Brady',
    logoUrl: 'flags/united_states.webp',
  },
  'Waldo Cortes-Acosta': {
    displayName: 'Waldo Cortes-Acosta',
    logoUrl: 'flags/dominican_republic.webp',
  },
  'Alexander Volkov': {
    displayName: 'Alexander Volkov',
    logoUrl: 'flags/russia.webp',
  },
  'Andre Petroski': {
    displayName: 'Andre Petroski',
    logoUrl: 'flags/united_states.webp',
  },
  'Benardo Sopaj': {
    displayName: 'Benardo Sopaj',
    logoUrl: 'flags/albania.webp',
  },
  'Daniel Barez': {
    displayName: 'Daniel Barez',
    logoUrl: 'flags/spain.webp',
  },
  'Daniel Santos': {
    displayName: 'Daniel Santos',
    logoUrl: 'flags/brazil.webp',
  },
  'Doo Ho Choi': {
    displayName: 'Doo Ho Choi',
    logoUrl: 'flags/south_korea.webp',
  },
  'Ivan Erslan': {
    displayName: 'Ivan Erslan',
    logoUrl: 'flags/croatia.webp',
  },
  'Juan Diaz': {
    displayName: 'Juan Diaz',
    logoUrl: 'flags/mexico.webp',
  },
  'Khaos Williams': {
    displayName: 'Khaos Williams',
    logoUrl: 'flags/united_states.webp',
  },
  'Nicolle Caliari': {
    displayName: 'Nicolle Caliari',
    logoUrl: 'flags/brazil.webp',
  },
  'Nikolay Veretennikov': {
    displayName: 'Nikolay Veretennikov',
    logoUrl: 'flags/kazakhstan.webp',
  },
  'Polyana Viana': {
    displayName: 'Polyana Viana',
    logoUrl: 'flags/brazil.webp',
  },
  'Tommy Gantt': {
    displayName: 'Tommy Gantt',
    logoUrl: 'flags/united_states.webp',
  },
  'Trey Ogden': {
    displayName: 'Trey Ogden',
    logoUrl: 'flags/united_states.webp',
  },
  'Tuco Tokkos': {
    displayName: 'Tuco Tokkos',
    logoUrl: 'flags/england.webp',
  },
  'Benson Henderson': {
    displayName: 'Benson Henderson',
    logoUrl: 'flags/united_states.webp',
  },
  'Patrick Habirora': {
    displayName: 'Patrick Habirora',
    logoUrl: 'flags/belgium.webp',
  },
  'Jake Hadley': {
    displayName: 'Jake Hadley',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Taylor Lapilus': {
    displayName: 'Taylor Lapilus',
    logoUrl: 'flags/france.webp',
  },
  'Jared Gooden': {
    displayName: 'Jared Gooden',
    logoUrl: 'flags/united_states.webp',
  },
  'Boris Atangana': {
    displayName: 'Boris Atangana',
    logoUrl: 'flags/cameroon.webp',
  },
  'Naoki Inoue': {
    displayName: 'Naoki Inoue',
    logoUrl: 'flags/japan.webp',
  },
  'Marcirley Alves': {
    displayName: 'Marcirley Alves',
    logoUrl: 'flags/brazil.webp',
  },
  'Gustavo Oliveira': {
    displayName: 'Gustavo Oliveira',
    logoUrl: 'flags/portugal.webp',
  },
  'Baris Adiguzel': {
    displayName: 'Baris Adiguzel',
    logoUrl: 'flags/turkey.webp',
  },
  'Joe Schilling': {
    displayName: 'Joe Schilling',
    logoUrl: 'flags/united_states.webp',
  },
  'Donegi Abena': {
    displayName: 'Donegi Abena',
    logoUrl: 'flags/suriname.webp',
  },
  'Youssouf Binate': {
    displayName: 'Youssouf Binate',
    logoUrl: 'flags/ivory_coast.webp',
  },
  'Movsar Ibragimov': {
    displayName: 'Movsar Ibragimov',
    logoUrl: 'flags/russia.webp',
  },
  'Luca Poclit': {
    displayName: 'Luca Poclit',
    logoUrl: 'flags/moldova.webp',
  },
  'Khamzat Abaev': {
    displayName: 'Khamzat Abaev',
    logoUrl: 'flags/russia.webp',
  },
  'Keweny Lopes': {
    displayName: 'Keweny Lopes',
    logoUrl: 'flags/brazil.webp',
  },
  'Adam Meskini': {
    displayName: 'Adam Meskini',
    logoUrl: 'flags/morocco.webp',
  },
  'Ashley Reece': {
    displayName: 'Ashley Reece',
    logoUrl: 'flags/united_kingdom.webp',
  },
  'Rustam Serbiev': {
    displayName: 'Rustam Serbiev',
    logoUrl: 'flags/russia.webp',
  },
  'Jose Henrique': {
    displayName: 'Jose Henrique',
    logoUrl: 'flags/brazil.webp',
  },
  'Ding Meng': {
    displayName: 'Ding Meng',
    logoUrl: 'flags/china.webp',
  },
  'Xiong Jingnan': {
    displayName: 'Xiong Jingnan',
    logoUrl: 'flags/china.webp',
  },
  'Jaqueline Amorim': {
    displayName: 'Jaqueline Amorim',
    logoUrl: 'flags/brazil.webp',
  },
  'Loma Lookboonmee': {
    displayName: 'Loma Lookboonmee',
    logoUrl: 'flags/thailand.webp',
  },
  'Rodrigo Vera': {
    displayName: 'Rodrigo Vera',
    logoUrl: 'flags/peru.webp',
  },
  'Zhu Kangjie': {
    displayName: 'Zhu Kangjie',
    logoUrl: 'flags/china.webp',
  },
  'Rei Tsuruya': {
    displayName: 'Rei Tsuruya',
    logoUrl: 'flags/japan.webp',
  },
  'Jake Matthews': {
    displayName: 'Jake Matthews',
    logoUrl: 'flags/australia.webp',
  },
  'Aoriqileng': {
    displayName: 'Aoriqileng',
    logoUrl: 'flags/china.webp',
  },
  'Luis Felipe Dias': {
    displayName: 'Luis Felipe Dias',
    logoUrl: 'flags/brazil.webp',
  },
  'Yi Sak Lee': {
    displayName: 'Yi Sak Lee',
    logoUrl: 'flags/south_korea.webp',
  },
  'Kai Asakura': {
    displayName: 'Kai Asakura',
    logoUrl: 'flags/japan.webp',
  },
  'Sergei Pavlovich': {
    displayName: 'Sergei Pavlovich',
    logoUrl: 'flags/russia.webp',
  },
  'Zhang Mingyang': {
    displayName: 'Zhang Mingyang',
    logoUrl: 'flags/china.webp',
  },
  'Conor McGregor': {
    displayName: 'Conor McGregor',
    logoUrl: 'flags/ireland.webp',
  },
  'Lone\'er Kavanagh': {
    displayName: 'Lone\'er Kavanagh',
    logoUrl: 'flags/england.webp',
  },
  'Cory Sandhagen': {
    displayName: 'Cory Sandhagen',
    logoUrl: 'flags/united_states.webp',
  },
  'Edmen Shahbazyan': {
    displayName: 'Edmen Shahbazyan',
    logoUrl: 'flags/united_states.webp',
  },
  'Brendan Allen': {
    displayName: 'Brendan Allen',
    logoUrl: 'flags/united_states.webp',
  },
  'Tom Nolan': {
    displayName: 'Tom Nolan',
    logoUrl: 'flags/australia.webp',
  },
  'Bryce Mitchell': {
    displayName: 'Bryce Mitchell',
    logoUrl: 'flags/united_states.webp',
  },
  'Yuneisy Duben': {
    displayName: 'Yuneisy Duben',
    logoUrl: 'flags/venezuela.webp',
  },
  'Jeisla Chaves': {
    displayName: 'Jeisla Chaves',
    logoUrl: 'flags/brazil.webp',
  },
  'Chelsea Chandler': {
    displayName: 'Chelsea Chandler',
    logoUrl: 'flags/united_states.webp',
  },
  'Edgar Chairez': {
    displayName: 'Edgar Chairez',
    logoUrl: 'flags/mexico.webp',
  },
  'Marcus McGhee': {
    displayName: 'Marcus McGhee',
    logoUrl: 'flags/united_states.webp',
  },
  'Elisha Ellison': {
    displayName: 'Elisha Ellison',
    logoUrl: 'flags/united_states.webp',
  },
  'Gable Steveson': {
    displayName: 'Gable Steveson',
    logoUrl: 'flags/united_states.webp',
  },
  'Artur Minev': {
    displayName: 'Artur Minev',
    logoUrl: 'flags/ukraine.webp',
  },
  'Ashley Barrett': {
    displayName: 'Ashley Barrett',
    logoUrl: 'flags/united_states.webp',
  },
  'Austin Ross': {
    displayName: 'Austin Ross',
    logoUrl: 'flags/united_states.webp',
  },
  'Christian Edwards': {
    displayName: 'Christian Edwards',
    logoUrl: 'flags/united_states.webp',
  },
  'David Evenson': {
    displayName: 'David Evenson',
    logoUrl: 'flags/united_states.webp',
  },
  'Elton Dedaj': {
    displayName: 'Elton Dedaj',
    logoUrl: 'flags/sweden.webp',
  },
  'Guram Gochashvili': {
    displayName: 'Guram Gochashvili',
    logoUrl: 'flags/georgia.webp',
  },
  'Melvin Jovel': {
    displayName: 'Melvin Jovel',
    logoUrl: 'flags/united_states.webp',
  },
  'Rodrigo Brauna': {
    displayName: 'Rodrigo Brauna',
    logoUrl: 'flags/brazil.webp',
  },
  'Sophie Lang': {
    displayName: 'Sophie Lang',
    logoUrl: 'flags/united_states.webp',
  },
  'Trevor Linderman': {
    displayName: 'Trevor Linderman',
    logoUrl: 'flags/united_states.webp',
  },
  'Willer Alves': {
    displayName: 'Willer Alves',
    logoUrl: 'flags/brazil.webp',
  },
  'Otari Tanzilovi': {
    displayName: 'Otari Tanzilovi',
    logoUrl: 'flags/georgia.webp',
  },
  'Shane Collins': {
    displayName: 'Shane Collins',
    logoUrl: 'flags/united_states.webp',
  },
  'Levan Chokheli': {
    displayName: 'Levan Chokheli',
    logoUrl: 'flags/georgia.webp',
  },
  'Leon Shahbazyan': {
    displayName: 'Leon Shahbazyan',
    logoUrl: 'flags/armenia.webp',
  },
  'Karol Rosa': {
    displayName: 'Karol Rosa',
    logoUrl: 'flags/brazil.webp',
  },
  'Murtazali Magomedov': {
    displayName: 'Murtazali Magomedov',
    logoUrl: 'flags/russia.webp',
  },
  'Christian Rodriguez': {
    displayName: 'Christian Rodriguez',
    logoUrl: 'flags/united_states.webp',
  },
  'Kevin Borjas': {
    displayName: 'Kevin Borjas',
    logoUrl: 'flags/peru.webp',
  },
  'Andre Lima': {
    displayName: 'Andre Lima',
    logoUrl: 'flags/brazil.webp',
  },
  'Ikram Aliskerov': {
    displayName: 'Ikram Aliskerov',
    logoUrl: 'flags/russia.webp',
  },
  'Abus Magomedov': {
    displayName: 'Abus Magomedov',
    logoUrl: 'flags/germany.webp',
  },
  'Theodor Berggren': {
    displayName: 'Theodor Berggren',
    logoUrl: 'flags/sweden.webp',
  },
  'Javier Reyes': {
    displayName: 'Javier Reyes',
    logoUrl: 'flags/colombia.webp',
  },
  'Nursulton Ruziboev': {
    displayName: 'Nursulton Ruziboev',
    logoUrl: 'flags/uzbekistan.webp',
  },
  'Eric Nolan': {
    displayName: 'Eric Nolan',
    logoUrl: 'flags/ireland.webp',
  },
  'Farman Hasanov': {
    displayName: 'Farman Hasanov',
    logoUrl: 'flags/azerbaijan.webp',
  },
  'Shara Magomedov': {
    displayName: 'Shara Magomedov',
    logoUrl: 'flags/russia.webp',
  },
  'Robert Whittaker': {
    displayName: 'Robert Whittaker',
    logoUrl: 'flags/australia.webp',
  },
  'Kai Kamaka III': {
    displayName: 'Kai Kamaka III',
    logoUrl: 'flags/united_states.webp',
  },
  'Damian Pinas': {
    displayName: 'Damian Pinas',
    logoUrl: 'flags/suriname.webp',
  },
  'Zachary Reese': {
    displayName: 'Zachary Reese',
    logoUrl: 'flags/united_states.webp',
  },
  'Ryan Gandra': {
    displayName: 'Ryan Gandra',
    logoUrl: 'flags/brazil.webp',
  },
  'Kamaru Usman': {
    displayName: 'Kamaru Usman',
    logoUrl: 'flags/nigeria.webp',
  },
  'Dricus Du Plessis': {
    displayName: 'Dricus Du Plessis',
    logoUrl: 'flags/south_africa.webp',
  },
  'Mitch Ramirez': {
    displayName: 'Mitch Ramirez',
    logoUrl: 'flags/united_states.webp',
  },
  'Jared Cannonier': {
    displayName: 'Jared Cannonier',
    logoUrl: 'flags/united_states.webp',
  },
  'Austin Bashi': {
    displayName: 'Austin Bashi',
    logoUrl: 'flags/united_states.webp',
  },
  'Levi Rodrigues Jr.': {
    displayName: 'Levi Rodrigues Jr.',
    logoUrl: 'flags/brazil.webp',
  },
  'Jean-Paul Lebosnoyani': {
    displayName: 'Jean-Paul Lebosnoyani',
    logoUrl: 'flags/united_states.webp',
  },
  'Anna Melisano': {
    displayName: 'Anna Melisano',
    logoUrl: 'flags/united_states.webp',
  },
  'RJ Harris': {
    displayName: 'RJ Harris',
    logoUrl: 'flags/united_states.webp',
  },
  'Alvin Hines': {
    displayName: 'Alvin Hines',
    logoUrl: 'flags/united_states.webp',
  },
  'Ramazan Temirov': {
    displayName: 'Ramazan Temirov',
    logoUrl: 'flags/uzbekistan.webp',
  },
  'Wellington Turman': {
    displayName: 'Wellington Turman',
    logoUrl: 'flags/brazil.webp',
  },
  'Islam Dulatov': {
    displayName: 'Islam Dulatov',
    logoUrl: 'flags/germany.webp',
  },
  'Damian Rzepecki': {
    displayName: 'Damian Rzepecki',
    logoUrl: 'flags/poland.webp',
  },
  'Magomed Zaynukov': {
    displayName: 'Magomed Zaynukov',
    logoUrl: 'flags/russia.webp',
  },
  'Valter Walker': {
    displayName: 'Valter Walker',
    logoUrl: 'flags/brazil.webp',
  },
  'Muhammad Said': {
    displayName: 'Muhammad Said',
    logoUrl: 'flags/russia.webp',
  },
  'Santiago Ponzinibbio': {
    displayName: 'Santiago Ponzinibbio',
    logoUrl: 'flags/argentina.webp',
  },
  'Magomed Tuchalov': {
    displayName: 'Magomed Tuchalov',
    logoUrl: 'flags/russia.webp',
  },
  'Mike Davis': {
    displayName: 'Mike Davis',
    logoUrl: 'flags/united_states.webp',
  },
  'Cody Gibson': {
    displayName: 'Cody Gibson',
    logoUrl: 'flags/united_states.webp',
  },
  'Abdul Hussein': {
    displayName: 'Abdul Hussein',
    logoUrl: 'flags/finland.webp',
  },
  'Magomed Ankalaev': {
    displayName: 'Magomed Ankalaev',
    logoUrl: 'flags/russia.webp',
  },
  'Shamil Musaev': {
    displayName: 'Shamil Musaev',
    logoUrl: 'flags/russia.webp',
  },
  'Thad Jean': {
    displayName: 'Thad Jean',
    logoUrl: 'flags/haiti.webp',
  },
  'Aleksandar Rakic': {
    displayName: 'Aleksandar Rakic',
    logoUrl: 'flags/austria.webp',
  },
  'Alexander Poppeck': {
    displayName: 'Alexander Poppeck',
    logoUrl: 'flags/germany.webp',
  },
  'Daniel Rodriguez': {
    displayName: 'Daniel Rodriguez',
    logoUrl: 'flags/united_states.webp',
  },
  'Dusko Todorovic': {
    displayName: 'Dusko Todorovic',
    logoUrl: 'flags/serbia.webp',
  },
  'Gilbert Urbina': {
    displayName: 'Gilbert Urbina',
    logoUrl: 'flags/united_states.webp',
  },
  'Hailey Cowan': {
    displayName: 'Hailey Cowan',
    logoUrl: 'flags/united_states.webp',
  },
  'Jovan Leka': {
    displayName: 'Jovan Leka',
    logoUrl: 'flags/serbia.webp',
  },
  'Kyle Prepolec': {
    displayName: 'Kyle Prepolec',
    logoUrl: 'flags/canada.webp',
  },
  'Ludovit Klein': {
    displayName: 'Ludovit Klein',
    logoUrl: 'flags/slovakia.webp',
  },
  'Marina Spasic': {
    displayName: 'Marina Spasic',
    logoUrl: 'flags/serbia.webp',
  },
  'Mateusz Rebecki': {
    displayName: 'Mateusz Rebecki',
    logoUrl: 'flags/poland.webp',
  },
  'Michael Oliveira': {
    displayName: 'Michael Oliveira',
    logoUrl: 'flags/brazil.webp',
  },
  'Milos Janicic': {
    displayName: 'Milos Janicic',
    logoUrl: 'flags/montenegro.webp',
  },
  'Nina Milosevic': {
    displayName: 'Nina Milosevic',
    logoUrl: 'flags/serbia.webp',
  },
  'Noah Gugnon': {
    displayName: 'Noah Gugnon',
    logoUrl: 'flags/canada.webp',
  },
  'Stephanie Luciano': {
    displayName: 'Stephanie Luciano',
    logoUrl: 'flags/brazil.webp',
  },
  'Vlasto Cepo': {
    displayName: 'Vlasto Cepo',
    logoUrl: 'flags/slovakia.webp',
  },
  'Billy Quarantillo': {
    displayName: 'Billy Quarantillo',
    logoUrl: 'flags/united_states.webp',
  },
  'Billy Ray Goff': {
    displayName: 'Billy Ray Goff',
    logoUrl: 'flags/united_states.webp',
  },
  'Borislav Nikolic': {
    displayName: 'Borislav Nikolic',
    logoUrl: 'flags/serbia.webp',
  },
  'Darren Elkins': {
    displayName: 'Darren Elkins',
    logoUrl: 'flags/united_states.webp',
  },
  'Diego Ferreira': {
    displayName: 'Diego Ferreira',
    logoUrl: 'flags/brazil.webp',
  },
  'Jose Montanha': {
    displayName: 'Jose Montanha',
    logoUrl: 'flags/brazil.webp',
  },
  'Yadier del Valle': {
    displayName: 'Yadier del Valle',
    logoUrl: 'flags/cuba.webp',
  },
  'Jessie Rosas': {
    displayName: 'Jessie Rosas',
    logoUrl: 'flags/mexico.webp',
  },
  'Miles Johns': {
    displayName: 'Miles Johns',
    logoUrl: 'flags/united_states.webp',
  },
  'Richie Miranda': {
    displayName: 'Richie Miranda',
    logoUrl: 'flags/united_states.webp',
  },
  'Carol Foro': {
    displayName: 'Carol Foro',
    logoUrl: 'flags/brazil.webp',
  },
  'GiGi Canuto': {
    displayName: 'GiGi Canuto',
    logoUrl: 'flags/brazil.webp',
  },
  'Mackenzie Dern': {
    displayName: 'Mackenzie Dern',
    logoUrl: 'flags/united_states.webp',
  },
  'Lucas Fernando': {
    displayName: 'Lucas Fernando',
    logoUrl: 'flags/brazil.webp',
  },
  'Taner Trembley': {
    displayName: 'Taner Trembley',
    logoUrl: 'flags/united_states.webp',
  },
  'Roman Puga': {
    displayName: 'Roman Puga',
    logoUrl: 'flags/mexico.webp',
  },
  'Mahamed Aly': {
    displayName: 'Mahamed Aly',
    logoUrl: 'flags/brazil.webp',
  },
  'Alik Lorenz': {
    displayName: 'Alik Lorenz',
    logoUrl: 'flags/united_states.webp',
  },
  'Cristian Perez': {
    displayName: 'Cristian Perez',
    logoUrl: 'flags/mexico.webp',
  },
  'Logan Paxton': {
    displayName: 'Logan Paxton',
    logoUrl: 'flags/united_states.webp',
  },
  'Trent Miller': {
    displayName: 'Trent Miller',
    logoUrl: 'flags/united_states.webp',
  },
  'Douglas Rodrigues': {
    displayName: 'Douglas Rodrigues',
    logoUrl: 'flags/brazil.webp',
  },
  'Kaik Brito': {
    displayName: 'Kaik Brito',
    logoUrl: 'flags/brazil.webp',
  },
  'Namo Fazil': {
    displayName: 'Namo Fazil',
    logoUrl: 'flags/iraq.webp',
  },
  'MarQuel Mederos': {
    displayName: 'MarQuel Mederos',
    logoUrl: 'flags/cuba.webp',
  },
  'Nasrat Haqparast': {
    displayName: 'Nasrat Haqparast',
    logoUrl: 'flags/afghanistan.webp',
  },
  'Elise Reed': {
    displayName: 'Elise Reed',
    logoUrl: 'flags/united_states.webp',
  },
  'Stanley Dorsainvil': {
    displayName: 'Stanley Dorsainvil',
    logoUrl: 'flags/united_states.webp',
  },
  'Terrance Chatman': {
    displayName: 'Terrance Chatman',
    logoUrl: 'flags/united_states.webp',
  },
  'Anthony Wint': {
    displayName: 'Anthony Wint',
    logoUrl: 'flags/united_states.webp',
  },
  'Ryan Kuse': {
    displayName: 'Ryan Kuse',
    logoUrl: 'flags/united_states.webp',
  },
  'Marcio Barbosa': {
    displayName: 'Marcio Barbosa',
    logoUrl: 'flags/brazil.webp',
  },
  'Cameron Nelson': {
    displayName: 'Cameron Nelson',
    logoUrl: 'flags/canada.webp',
  },
  'Hector Santiago': {
    displayName: 'Hector Santiago',
    logoUrl: 'flags/brazil.webp',
  },
  'Francesco Nuzzi': {
    displayName: 'Francesco Nuzzi',
    logoUrl: 'flags/italy.webp',
  },
  'Xiao Long': {
    displayName: 'Xiao Long',
    logoUrl: 'flags/china.webp',
  },
  'Sean Woodson': {
    displayName: 'Sean Woodson',
    logoUrl: 'flags/united_states.webp',
  },
  'Jack Jenkins': {
    displayName: 'Jack Jenkins',
    logoUrl: 'flags/australia.webp',
  },
  'Nilson Rojas': {
    displayName: 'Nilson Rojas',
    logoUrl: 'flags/peru.webp',
  },
  'Bilal Hasan': {
    displayName: 'Bilal Hasan',
    logoUrl: 'flags/united_states.webp',
  },
  'Liu Ce': {
    displayName: 'Liu Ce',
    logoUrl: 'flags/china.webp',
  },
  'Yan Xiaonan': {
    displayName: 'Yan Xiaonan',
    logoUrl: 'flags/china.webp',
  },
};
